export const CLIENT_STORAGE_PREFIX = "scrumlr/";
export const APP_VERSION_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}app_version`;
export const COOKIE_CONSENT_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}cookie_consent`;
export const LOCALE_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}locale`;
export const THEME_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}theme`;
export const CUSTOM_TIMER_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}custom_timer`;
export const CUSTOM_NUMBER_OF_VOTES_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}custom_number_of_votes`;
export const CUMULATIVE_VOTING_DEFAULT_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}cumulative_voting_default`;
export const HOTKEY_NOTIFICATIONS_ENABLE_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}hotkeyNotificationsEnable`;
export const BOARD_REACTIONS_ENABLE_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}boardReactionsEnable`;
export const SKIN_TONE_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}skinTone`;
export const RECENT_EMOJIS_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}recentEmojis`;
export const SNOWFALL_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}snowfall`;
export const SNOWFALL_NOTIFICATION_STORAGE_KEY = `${CLIENT_STORAGE_PREFIX}snowfall_notification`;
export const RECOMMENDED_FAVOURITES_KEY = `${CLIENT_STORAGE_PREFIX}recommendedTemplateFavourites`;
